const es = {
	appName: 'resolvo.me',
	welcomeMessage: 'Administra y sigue tus propósitos de Año Nuevo',
	signInToYourAccount: 'Inicia sesión en tu cuenta',
	createYourAccount: 'Crea tu cuenta',
	firstName: 'Nombre',
	lastName: 'Apellido',
	emailAddress: 'Correo electrónico',
	password: 'Contraseña',
	confirmPassword: 'Confirmar contraseña',
	signUp: 'Registrarse',
	signIn: 'Iniciar sesión',
	processing: 'Procesando...',
	dontHaveAccountSignUp: '¿No tienes una cuenta? Regístrate',
	alreadyHaveAccountSignIn: '¿Ya tienes una cuenta? Inicia sesión',
	resetPassword: 'Restablecer contraseña',
	sendResetEmail: 'Enviar correo de restablecimiento',
	sending: 'Enviando...',
	rememberMe: 'Recuérdame',
	forgotPassword: '¿Olvidaste tu contraseña?',
	adminDashboard: 'Panel de administrador',
	myDashboard: 'Mi panel',
	myProfile: 'Mi perfil',
	settings: 'Ajustes',
	signOut: 'Cerrar sesión',
	addResolution: 'Agregar objetivo',
	cancel: 'Cancelar',
	makePrivate: 'Hacer este objetivo privado (cifrado)',
	encryptionKey: 'Clave de cifrado',
	enterEncryptionKey: 'Ingrese una clave segura para cifrar su objetivo',
	rememberEncryptionKey: '¡Recuerda esta clave! — la necesitarás para ver tu objetivo privado',
	type: 'Tipo',
	year: 'Año',
	resolutionText: 'Texto del objetivo',
	exampleCount: 'ej., Leer 20 libros este año',
	exampleBinary: 'ej., Comprar un coche nuevo',
	exampleMetric: 'ej., Perder 10 kg para fin de año',
	startValue: 'Valor inicial',
	targetValue: 'Valor objetivo',
	unit: 'Unidad',
	unitExample: 'ej., kg, km, horas, USD',
	exampleStreak: 'ej., Beber 2 L de agua cada día (registrar diario)',
	currentStreak: 'Racha actual',
	longestStreak: 'Racha más larga',
	never: 'Nunca',
	measurements: 'Mediciones',
	lastLogDate: 'Fecha del último registro',
	daysInARow: 'días seguidos',
	dailyInARow: 'días seguidos',
	weeklyInARow: 'semanas seguidas',
	monthlyInARow: 'meses seguidos',
	period: 'Período',
	daily: 'Diario',
	weekly: 'Semanal',
	monthly: 'Mensual',
	value: 'Valor',
	note: 'Nota',
	add: 'Agregar',
	loading: 'Cargando...',
	resolutions: 'Objetivos',
	claimAccount: 'Debes reclamar tu cuenta para agregar objetivos',
	timeUntilNewYear: 'Tiempo hasta el Año Nuevo',
	contactAdmin: 'Contacta al administrador sobre tus objetivos...',
	verifyingLink: 'Verificando tu enlace...',
	invalidLink: 'Enlace inválido',
	goToLogin: 'Ir a iniciar sesión',
	completeAccountClaim: 'Completar reclamación de cuenta',
	emailVerifiedCreatePassword: '¡Correo verificado! Crea una contraseña para asegurar tu cuenta.',
	accountLabel: 'Cuenta',
	createPasswordLabel: 'Crear contraseña',
	confirmPasswordLabel: 'Confirmar contraseña',
	enterYourPassword: 'Ingresa tu contraseña',
	confirmYourPassword: 'Confirma tu contraseña',
	creatingAccount: 'Creando cuenta...',
	completeClaim: 'Completar reclamación',
	backToLogin: 'Volver a iniciar sesión',
	passwordMismatch: 'Las contraseñas no coinciden',
	passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
	invalidOrExpiredLink: 'Enlace de verificación inválido o caducado',
	linkNotFound: 'Enlace de verificación no encontrado o caducado',
	linkExpiredRequestNew: 'El enlace ha caducado. Solicita uno nuevo.',
	accountAlreadyClaimed: 'Esta cuenta ya ha sido reclamada',
	failedToCreateAccount: 'No se pudo crear la cuenta. Por favor, inténtalo de nuevo.',
	claimErrorGeneric: 'Ocurrió un error al completar la reclamación',
	resolution: 'objetivo',
	total: 'total',
	overallProgress: 'Progreso general',
	progress: 'Progreso',
	completed: 'Completado',
	complete: 'Completar',
	'waiting-completion': 'Esperando finalización',
	ahead: 'Adelantado',
	behind: 'Atrasado',
	'on-track': 'En camino',
	failed: 'Fallido',
	private: 'Privado',
	decrypt: 'Descifrar',
	delete: 'Eliminar',
	backToPlrofile: '← Volver al perfil',
	customizeProfile: 'Personaliza tu perfil y preferencias',
	displayNameHeading: 'Nombre para mostrar',
	displayNameHelp: 'Cómo aparece tu nombre en tu perfil',
	enterDisplayName: 'Ingresa tu nombre para mostrar',
	currentlyShowing: 'Mostrando actualmente',
	emailPreferences: 'Preferencias de correo',
	requiredForReceiving: 'Requerido para recibir notificaciones por correo',
	weeklyStatusEmail: 'Correo de estado semanal',
	emailRequired: '(Se requiere dirección de correo)',
	timerStyle: 'Estilo del temporizador',
	chooseTimer: 'Elige cómo quieres que aparezca tu cuenta regresiva',
	selected: 'Seleccionado',
	preview: 'Vista previa:',
	saving: 'Guardando...',
	saveSettings: 'Guardar configuración',
	count: 'Conteo',
	binary: 'Sí/No',
	metric: 'Métrica',
	streak: 'Racha',
	yes: 'Sí',
	no: 'No',
	'timer.months': 'Meses',
	'timer.days': 'Días',
	'timer.hours': 'Horas',
	'timer.minutes': 'Minutos',
	'timer.seconds': 'Segundos',
	'timer.monthsShort': 'MES',
	'timer.daysShort': 'D',
	'timer.hoursShort': 'HRS',
	'timer.minutesShort': 'MIN',
	'timer.secondsShort': 'SEC',
	'timer.monthsShortLower': 'mes',
	'timer.daysShortLower': 'd',
	'timer.hoursShortLower': 'h',
	'timer.minutesShortLower': 'm',
	'timer.secondsShortLower': 's',
	'timer.yearEnded': '🎉 ¡El año terminó!',
	'timer.option.basic.name': 'Minimalista en una línea',
	'timer.option.basic.desc': 'Formato limpio y simple en una sola línea',
	'timer.option.card.name': 'Tarjetas coloridas',
	'timer.option.card.desc': 'Tarjetas coloridas para cada unidad de tiempo',
	'timer.option.clock.name': 'Estilo reloj digital',
	'timer.option.clock.desc': 'Estilo de reloj digital audaz',
	'timer.option.circular.name': 'Estilo anillo de progreso',
	'timer.option.circular.desc': 'Indicadores circulares de progreso modernos',
	'timer.option.flip.name': 'Animación FlipCard',
	'timer.option.flip.desc': 'Tarjetas animadas (solo escritorio)',
	'timer.option.icon.name': 'Texto con iconos',
	'timer.option.icon.desc': 'Emojis con texto abreviado',
	resolutionUpdatedSuccessfully: '¡Objetivo actualizado correctamente!',
	errorUpdatingResolution: 'Error al actualizar el objetivo',
	failedToUpdateResolution: 'Error al actualizar el objetivo',
	settingsUpdatedSuccessfully: '¡Configuración actualizada correctamente!',
	errorDeletingResolution: 'Error al eliminar el objetivo',
	failedToDeleteResolution: 'No se pudo eliminar el objetivo',
	failedToUpdateSettings: 'No se pudieron actualizar los ajustes',
	settingsSavedSuccessfully: '¡Configuración guardada correctamente!',
	failedToSaveSettings: 'No se pudieron guardar los ajustes',
	errorSavingSettings: 'Error al guardar los ajustes',
	resolutionDeletedSuccessfully: '¡Objetivo eliminado correctamente!',
	// Landing page
	landingHeroTitle: 'Convierte tus metas en impulso',
	landingHeroSubtitle:
		'resolvo.me te ayuda a definir resoluciones significativas, seguir el progreso con propósito y convertir tus sueños en hábitos duraderos.',
	landingGetStarted: 'Comienza tu viaje',
	landingLearnMore: 'Ver cómo funciona',
	landingAndroidComingSoon: '📱 App de Android próximamente',
	landingAimTitle: '¿Por qué resolvo.me?',
	landingAimDesc:
		'Creemos en el poder de las metas claras y el seguimiento constante. resolvo.me está diseñado para personas que quieren tener éxito — no por la perfección, sino por el progreso.',
	landingMission1Title: 'Evita la caída de febrero',
	landingMission1Desc:
		'La mayoría de las resoluciones de Año Nuevo fallan en febrero — no porque las metas sean malas, sino porque dejamos de seguirlas.',
	landingMission2Title: 'Convierte la intención en acción',
	landingMission2Desc:
		'El cambio real no proviene solo de promesas. Proviene de decisiones diarias, reflexión semanal y ver cómo tu progreso se acumula con el tiempo.',
	landingMission3Title: 'Simplifica el proceso',
	landingMission3Desc:
		'Establece tus metas, registra tu progreso, obtén retroalimentación semanal y ve qué funciona.',
	landingMission4Title: 'Construye capacidad duradera',
	landingMission4Desc: 'El cambio duradero no se trata de perfección — se trata de consistencia.',
	landingFeature1Title: 'Varios tipos de objetivos',
	landingFeature1Desc: 'Elige el método de seguimiento que se adapte a tu meta',
	landingFeature2Title: 'Rastrear y visualizar',
	landingFeature2Desc: 'Ve tu progreso mediante gráficos, rachas e insights significativos',
	landingFeature3Title: 'Actualizaciones semanales',
	landingFeature3Desc: 'Mantente responsable con resúmenes por correo cada semana',
	landingFeature4Title: 'Seguro y privado',
	landingFeature4Desc: 'Tus datos están cifrados. Tus metas son tuyas.',
	landingResolutionTypesTitle: 'Tipos de resoluciones',
	landingResolutionTypesSubtitle: 'Elige el formato que mejor se adapte a tu meta',
	landingBinaryType: 'Binario (Sí/No)',
	landingBinaryDesc: 'Comprobaciones diarias simples para hábitos y rutinas',
	landingBinaryExample1: 'Comprar un coche nuevo',
	landingBinaryExample2: 'Encontrar un nuevo trabajo',
	landingCountType: 'Conteo',
	landingCountDesc: 'Rastrea cuántas veces haces algo',
	landingCountExample1: 'Leer 20 libros este año',
	landingCountExample2: 'Escribir 50 publicaciones de blog este año',
	landingMetricType: 'Métrica',
	landingMetricDesc: 'Rastrea progreso numérico con valor inicial y objetivo',
	landingMetricExample1: 'Perder 10 kg para fin de año',
	landingMetricExample2: 'Ahorrar $5,000 este año',
	landingStreakType: 'Racha',
	landingStreakDesc: 'Construye días consecutivos de éxito para amplificar la motivación',
	landingStreakExample1: 'Beber 2L de agua diariamente',
	landingStreakExample2: 'Escribir 500 palabras diarias para tu novela',
	landingQuote1: 'El éxito es el producto de los hábitos diarios — no de transformaciones únicas.',
	landingQuote1Author: 'James Clear',
	landingQuote2: 'El secreto de avanzar es empezar.',
	landingQuote2Author: 'Mark Twain',
	landingFeaturesTitle: 'Características diseñadas para el éxito',
	landingFeatureLogging: 'Registro con un toque',
	landingFeatureLoggingDesc: 'Registra tu progreso en segundos, en cualquier lugar',
	landingFeatureHistory: 'Historial de progreso',
	landingFeatureHistoryDesc: 'Revisa todas tus entradas y ve cuánto has avanzado',
	landingFeatureReminders: 'Recordatorios inteligentes',
	landingFeatureRemindersDesc: 'Recordatorios opcionales para mantenerte en camino',
	landingFeatureExport: 'Exporta tus datos',
	landingFeatureExportDesc: 'Descarga tus datos cuando quieras — son tuyos',
	landingCtaTitle: '¿Listo para hacer de este tu mejor año?',
	landingCtaDesc: 'Únete a miles de personas que ya trabajan hacia sus metas.',
	landingCtaButton: 'Crea tu primera resolución',
	landingFooterAbout: 'resolvo.me: Simple. Privado. Diseñado para personas que realmente quieren cambiar.',
	landingFooterContact: '¿Preguntas? Contáctanos o visita la app',
};

export default es;
